import { render, staticRenderFns } from "./PrepaidGroup.vue?vue&type=template&id=48291bb9"
import script from "./PrepaidGroup.vue?vue&type=script&lang=js"
export * from "./PrepaidGroup.vue?vue&type=script&lang=js"
import style0 from "./PrepaidGroup.vue?vue&type=style&index=0&id=48291bb9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports